export const RESULT_TYPE = 'result'
export const FORECAST_TYPE = 'forecast'
